/**
 * Shared order-section notification sound (orders, shopping-list, quotes).
 * Plays the locally hosted MP3 asset — no synthesis or substitution.
 */
export const ORDER_CHIME_VERSION = "pu-order-chime-v3-705155edf65e";
export const ORDER_CHIME_SRC = "/pipeup-order-notify-v3-705155edf65e.mp3";

/**
 * Play the supplied notification MP3 once.
 * Resumes AudioContext when present so existing unlock/gesture paths stay valid.
 * @param {{ current: AudioContext | null }} audioCtxRef
 */
export function playOrderNotificationChime(audioCtxRef) {
  try {
    if (typeof window !== "undefined") {
      window.__PU_ORDER_CHIME_VERSION = ORDER_CHIME_VERSION;
      window.__PU_ORDER_CHIME_SRC = ORDER_CHIME_SRC;
    }

    // Preserve existing browser-unlock behavior used by enableSound / تست صدا.
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (Ctx) {
      if (!audioCtxRef.current) audioCtxRef.current = new Ctx();
      if (audioCtxRef.current.state === "suspended") {
        audioCtxRef.current.resume().catch(() => {});
      }
    }

    const audio = new Audio(ORDER_CHIME_SRC);
    audio.preload = "auto";
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {});
    }
  } catch (_) {
    /* ignore autoplay / Audio errors */
  }
}
